import { render, staticRenderFns } from "./CurriculumStepField.vue?vue&type=template&id=fdb0f942&scoped=true&lang=pug"
import script from "./CurriculumStepField.vue?vue&type=script&lang=js"
export * from "./CurriculumStepField.vue?vue&type=script&lang=js"
import style0 from "./CurriculumStepField.vue?vue&type=style&index=0&id=fdb0f942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb0f942",
  null
  
)

export default component.exports